module.exports = __webpack_public_path__ + "static/img/wall-outlet-mk-2_256.fdc9700.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wall-outlet-mk-2_256.png
// module id = Q8/N
// module chunks = 0